import { FC, useCallback, useEffect, useState } from 'react'
import AOS from 'aos'
import { CDN_URL } from 'services/config'
import Image from 'next/image'
import {
  HeaderServiceConstant,
  HeaderTechConstant,
} from 'constants/HeaderTabConstant'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { Button, Col, Container, Row } from 'react-bootstrap'

const Menu: FC<{ handleMenu }> = ({ handleMenu }) => {
  const router = useRouter()
  const [showCompany, setShowCompany] = useState(false)
  const [mainMenu, setMainMenu] = useState(true)
  const [seviceMenu, setSeviceMenu] = useState(false)
  const [technologyMenu, setTechnologyMenu] = useState(false)
  const [solutionsMenu, setSolutionsMenu] = useState(false)
  const [fixedContactArea, setFixedContactArea] = useState(true)
  const handleCompany = () => setShowCompany(!showCompany)

  const isClickCompany = showCompany === false

  const handleServices = () => {
    setMainMenu(false)
    setSeviceMenu(true)
    setFixedContactArea(false)
  }
  const handleServicesClose = () => {
    setMainMenu(true)
    setSeviceMenu(false)
    setFixedContactArea(true)
  }
  const handleTechnology = () => {
    setMainMenu(false)
    setTechnologyMenu(true)
    setFixedContactArea(false)
  }
  const handleTechnologyClose = () => {
    setMainMenu(true)
    setTechnologyMenu(false)
    setFixedContactArea(true)
  }
  const handleSolutions = () => {
    setMainMenu(false)
    setSolutionsMenu(true)
    setFixedContactArea(false)
  }
  const handleSolutionsClose = () => {
    setMainMenu(true)
    setSolutionsMenu(false)
    setFixedContactArea(true)
  }
  useEffect(() => {
    AOS.init({ disable: 'mobile' })
  }, [])
  const RenderTabOption = useCallback((Option: any) => {
    return (
      <>
        {Object.keys(Option).map((tech) => (
          <Col lg={3} md={6} className="mt-3 mt-lg-4" key={Option[tech].id}>
            <div className="menuTitleSm text-decoration-none">
              {Option[tech].titleNoLink}
            </div>
            <Link
              href={Option[tech].link}
              className="menuTitleSm text-decoration-none"
            >
              {Option[tech].title}
            </Link>
            <div className="menutextSm">{Option[tech].description}</div>
            <div className="d-flex flex-wrap align-items-center text-white">
              {Option[tech].tags.length > 0 &&
                Option[tech].tags.map(({ tag, sublink, subid }: any) => (
                  <>
                    <Link
                      href={sublink}
                      key={subid}
                      className="smallLink2 text-nowrap"
                    >
                      {tag}
                    </Link>
                    <span className="px-2">|</span>
                  </>
                ))}
            </div>
          </Col>
        ))}
      </>
    )
  }, [])
  return (
    <div className="fixedMenu fixed-top">
      <div className="fixedMenu_header">
        <Container>
          <div className="d-flex align-items-center justify-content-between py-4">
            {/* <Link href="/">
              <img
                src="/assets/images/logo.svg"
                className="img-fluid fixedmenu_logo"
                alt="Webclues Infotech"
              />
            </Link> */}
            <Button
              variant="link"
              className="p-0 menuButton ms-auto"
              onClick={handleMenu}
            >
              BA
              <br />
              CK
            </Button>
          </div>
        </Container>
      </div>
      <Container>
        <div className="fixedMenu_inner">
          <Row className="fixMenu_row">
            <Col lg={12}>
              {fixedContactArea && (
                <div className="menu_info_blocks d-flex">
                  <div className="right_block">
                    <div className="top_menu_sec">
                      <h3 className="title">Contact Information</h3>
                      <p className="infotitle">
                        Give us a shout and we’ll set up a meeting
                      </p>
                      <div className="middle_sc_links pt-lg-3">
                        <div className="linkitem">
                          <Image
                            src={`/assets/images/mail-small.svg`}
                            alt="img"
                            className="me-2"
                            width={19}
                            height={14}
                          />
                          <a href="mailto:sales@webcluesinfotech.com">
                            sales@webcluesinfotech.com
                          </a>
                        </div>
                        <div className="linkitem">
                          <Image
                            src={`/assets/images/skype-small.svg`}
                            alt="img"
                            className="me-2"
                            width={19}
                            height={19}
                          />
                          <a href="skype:webcluesinfotech?chat">
                            webcluesinfotech
                          </a>
                        </div>
                        <div className="linkitem">
                          <Image
                            src={`/assets/images/phone-small.png`}
                            alt="img"
                            className="me-2"
                            width={20}
                            height={20}
                          />
                          <a href="tel:+918141068282">+91-814-106-8282</a>
                        </div>
                        <div className="linkitem">
                          <Image
                            src={`/assets/images/phone-small.png`}
                            alt="img"
                            className="me-2"
                            width={20}
                            height={20}
                          />
                          <a href="tel:+19783099910">+1-(978)-309-9910</a>
                        </div>

                        <div className="linkitem">
                          <Image
                            src={`/assets/images/phone-small.png`}
                            alt="img"
                            className="me-2"
                            width={20}
                            height={20}
                          />
                          <a href="tel:+971502578857">+971-50-257-8857</a>
                        </div>
                      </div>
                      <div className="py-2 pb-lg-5 pt-lg-5">
                        <Button
                          variant="alink"
                          className="GetQuoteBtn DarkQuoteBtn"
                          onClick={() => {
                            handleMenu()
                            router.push('/get-quote')
                          }}
                        >
                          Get A Quote
                        </Button>
                      </div>
                    </div>
                    <div className="last_menu_sec pt-2 pt-lg-5">
                      <div className="social_icons">
                        <Link
                          href="https://www.linkedin.com/company/webclues-infotech"
                          target="_blank"
                          className="text-text-decoration-none"
                          rel="noreferrer"
                        >
                          <Image
                            src={`/assets/images/linkedine_ic.png`}
                            alt="img"
                            width={35}
                            height={35}
                          />
                        </Link>
                        <Link
                          href="https://www.facebook.com/WebCluesInfotechLLP/"
                          target="_blank"
                          className="text-text-decoration-none"
                          rel="noreferrer"
                        >
                          <Image
                            src={`/assets/images/facebook_ic.png`}
                            alt="img"
                            width={35}
                            height={35}
                          />
                        </Link>
                        <Link
                          href="https://www.instagram.com/webcluesinfotech/"
                          target="_blank"
                          className="text-text-decoration-none"
                          rel="noreferrer"
                        >
                          <Image
                            src={`/assets/images/instagram_ic.png`}
                            alt="img"
                            width={35}
                            height={35}
                          />
                        </Link>
                        <Link
                          href="https://twitter.com/Webcluesinfo"
                          target="_blank"
                          className="text-text-decoration-none"
                          rel="noreferrer"
                        >
                          <Image
                            src={`/assets/images/twitter_ic.png`}
                            alt="img"
                            width={35}
                            height={35}
                          />
                        </Link>

                        {/* <Link href="https://www.behance.net/webcluesin486f/">
                          <a
                            target="_blank"
                            className="text-text-decoration-none"
                            rel="noreferrer"
                          >
                            <img src="/assets/images/be_ic.png" alt="img" />
                          </a>
                        </Link> */}
                      </div>
                      <div className="copyright mt-2 mt-xxl-4">
                        Copyright &copy; {new Date().getFullYear()} WebClues
                        Infotech
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </Col>
            <Col lg={12}>
              {mainMenu && (
                <Row className="right_inner_menu">
                  <Col md={6} lg={4}>
                    <div className="menuLink" data-aos="fade-up">
                      <Button
                        variant="link"
                        className="biglink"
                        onClick={() => {
                          handleMenu()
                          router.push('/about-us')
                        }}
                      >
                        About Us
                      </Button>
                      <div className="opacity-50 text-white fs-xl-18px fs-14px fw-400">
                        Know who we are
                      </div>
                    </div>
                  </Col>
                  <Col md={6} lg={4}>
                    <div className="menuLink" data-aos="fade-up">
                      <div className="d-flex align-items-center">
                        <Button
                          variant="link"
                          className="biglink"
                          onClick={() => {
                            handleMenu()
                            router.push('/it-solutions')
                          }}
                        >
                          Services
                        </Button>
                        <Button
                          className="innerMenuShow plus_minus_btn"
                          variant="link"
                          onClick={handleServices}
                        >
                          +
                        </Button>
                      </div>
                      <div className="opacity-50 text-white fs-xl-18px fs-14px fw-400">
                        Unparalleled Software Engineering Expertise
                      </div>
                    </div>
                  </Col>
                  <Col md={6} lg={4}>
                    <div className="menuLink" data-aos="fade-up">
                      <div className="d-flex align-items-center">
                        <Button
                          variant="link"
                          className="biglink"
                          onClick={() => {
                            handleMenu()
                            router.push('/technology')
                          }}
                        >
                          Technology
                        </Button>
                        <Button
                          variant="link"
                          onClick={handleTechnology}
                          className="plus_minus_btn"
                        >
                          +
                        </Button>
                      </div>
                      <div className="opacity-50 text-white fs-xl-18px fs-14px fw-400">
                        Shaping the future with advanced tech-stack
                      </div>
                    </div>
                  </Col>
                  <Col md={6} lg={4}>
                    <div
                      className="menuLink"
                      data-aos="fade-up"
                      data-aos-delay="100"
                    >
                      <div className="d-flex align-items-center">
                        <Button
                          variant="link"
                          className="biglink"
                          onClick={handleSolutions}
                        >
                          Solutions
                        </Button>
                        <Button
                          variant="link"
                          onClick={handleSolutions}
                          className="plus_minus_btn"
                        >
                          +
                        </Button>
                      </div>
                      <div className="opacity-50 text-white fs-xl-18px fs-14px fw-400">
                        Industry-specific solutions
                      </div>
                    </div>
                  </Col>
                  <Col md={6} lg={4}>
                    <div
                      className="menuLink"
                      data-aos="fade-up"
                      data-aos-delay="100"
                    >
                      <Button
                        variant="link"
                        className="biglink"
                        onClick={() => {
                          handleMenu()
                          router.push('/portfolio')
                        }}
                      >
                        Work
                      </Button>
                      <div className="opacity-50 text-white fs-xl-18px fs-14px fw-400">
                        Innovative and Creative portfolio
                      </div>
                    </div>
                  </Col>
                  <Col md={6} lg={4}>
                    <div
                      className="menuLink"
                      data-aos="fade-up"
                      data-aos-delay="100"
                    >
                      <div className="d-flex align-items-center">
                        <Button
                          variant="link"
                          className="biglink"
                          onClick={handleCompany}
                        >
                          Company
                        </Button>
                        <Button
                          variant="link"
                          onClick={handleCompany}
                          className="plus_minus_btn"
                        >
                          {isClickCompany ? '+' : '-'}
                        </Button>
                      </div>
                      {showCompany ? (
                        <div className="d-flex align-items-center text-white flex-wrap flex-xl-nowrap">
                          <Button
                            variant="alink"
                            className="smallLink text-nowrap"
                            onClick={() => {
                              handleMenu()
                              router.push('/our-team')
                            }}
                          >
                            Team
                          </Button>
                          <span className="px-2">|</span>
                          <Button
                            variant="alink"
                            className="smallLink text-nowrap"
                            onClick={() => {
                              handleMenu()
                              router.push('/events-gallery')
                            }}
                          >
                            Events
                          </Button>
                          <span className="px-2">|</span>
                          <Button
                            variant="alink"
                            className="smallLink text-nowrap"
                            onClick={() => {
                              handleMenu()
                              router.push('/join-our-team')
                            }}
                          >
                            Current Opening
                          </Button>
                        </div>
                      ) : (
                        <div className="opacity-50 text-white fs-xl-18px fs-14px fw-400">
                          Your Vision, Our Creation
                        </div>
                      )}
                    </div>
                  </Col>
                  <Col md={6} lg={4}>
                    <div
                      className="menuLink"
                      data-aos="fade-up"
                      data-aos-delay="200"
                    >
                      <Button
                        variant="link"
                        className="biglink"
                        onClick={() => {
                          handleMenu()
                          router.push('/blog')
                        }}
                      >
                        Blog
                      </Button>
                      <div className="opacity-50 text-white fs-xl-18px fs-14px fw-400">
                        Latest information and updates
                      </div>
                    </div>
                  </Col>
                  <Col md={6} lg={4}>
                    <div
                      className="menuLink"
                      data-aos="fade-up"
                      data-aos-delay="200"
                    >
                      <Button
                        variant="link"
                        className="biglink"
                        onClick={() => {
                          handleMenu()
                          router.push('/contact-us')
                        }}
                      >
                        Contact Us
                      </Button>
                      <div className="opacity-50 text-white fs-xl-18px fs-14px fw-400">
                        Get In Touch with Us
                      </div>
                    </div>
                  </Col>
                  <Col md={12} lg={12}>
                    <div className="corporate_profile">
                      <Link
                        href="/assets/images/corporate-pdf/corporate-presentation.pdf"
                        target="_blank"
                        className="copfllink text-decoration-none"
                      >
                        <span className="infoText_copfllink">
                          We deliver value with information.
                        </span>
                        <span className="orange_copfllink">
                          Explore corporate Profile
                        </span>
                      </Link>
                    </div>
                  </Col>
                </Row>
              )}
              {seviceMenu && (
                <div className="px-0 px-lg-0 fixedMenuLink" data-aos="fade-up">
                  <div className="menuLink">
                    <div className="d-flex align-items-center">
                      {/* <div className="menuTitle biglink">Services</div> */}

                      <Button
                        variant="link"
                        // onClick={() => {
                        //   handleMenu()
                        //   router.push('/services')
                        // }}
                        className="biglink btn btn-link"
                      >
                        Services
                      </Button>
                      <Button
                        variant="link"
                        onClick={handleServicesClose}
                        className="plus_minus_btn "
                      >
                        -
                      </Button>
                    </div>
                    <div className="menuSubtext opacity-1 text-white fs-xl-18px fs-14px fw-400">
                      Customized Solutions
                    </div>
                  </div>
                  <div className="menu_scrollbar">
                    <div className="inner_menu_scrollbar">
                      <Row className="mt-lg-2">
                        {RenderTabOption(HeaderServiceConstant)}
                      </Row>
                    </div>
                  </div>
                </div>
              )}
              {technologyMenu && (
                <div
                  className="d-flex flex-column px-0 px-lg-0 fixedMenuLink"
                  data-aos="fade-up"
                >
                  <div className="menuLink">
                    <div className="d-flex align-items-center">
                      {/* <div className="menuTitle">Technology</div> */}
                      <Button
                        variant="link"
                        className="biglink btn btn-link"
                        // onClick={() => {
                        //   handleMenu()
                        //   router.push('/services')
                        // }}
                      >
                        Technology
                      </Button>
                      <Button
                        variant="link"
                        onClick={handleTechnologyClose}
                        className="plus_minus_btn"
                      >
                        -
                      </Button>
                    </div>
                    <div className="menuSubtext opacity-1 text-white fs-xl-18px fs-14px fw-400">
                      Shaping the future with advanced tech-stack
                    </div>
                  </div>
                  <div className="menu_scrollbar">
                    <div className="inner_menu_scrollbar">
                      <Row className="mt-lg-2">
                        {RenderTabOption(HeaderTechConstant)}
                      </Row>
                    </div>
                  </div>
                </div>
              )}
              {solutionsMenu && (
                <div className="px-0 px-lg-0 fixedMenuLink" data-aos="fade-up">
                  <div className="menuLink">
                    <div className="d-flex align-items-center">
                      <Button
                        variant="link"
                        className="biglink btn btn-link"
                        onClick={handleSolutionsClose}
                      >
                        Solutions
                      </Button>
                      <Button
                        variant="link"
                        onClick={handleSolutionsClose}
                        className="plus_minus_btn"
                      >
                        -
                      </Button>
                    </div>
                    <div className="menuSubtext opacity-1 text-white fs-xl-18px fs-14px fw-400">
                      Industry-specific solutions
                    </div>
                  </div>
                  <div className="menu_scrollbar">
                    <div className="inner_menu_scrollbar">
                      <Row className="mt-lg-2">
                        <Col lg={3} md={6} className="mt-3 mt-lg-4">
                          <Link
                            href="/how-to-create-a-food-delivery-app-like-zomato"
                            className="menuTitleSm text-decoration-none fw-500"
                          >
                            Food Delivery App Like Zomato
                          </Link>
                        </Col>
                        <Col lg={3} md={6} className="mt-3 mt-lg-4">
                          <Link
                            href="/cost-to-create-a-taxi-app-like-uber"
                            className="menuTitleSm text-decoration-none fw-500"
                          >
                            Taxi App like Uber
                          </Link>
                        </Col>
                        <Col lg={3} md={6} className="mt-3 mt-lg-4">
                          <Link
                            href="//how-to-create-a-video-streaming-app-like-netflix"
                            className="menuTitleSm text-decoration-none fw-500"
                          >
                            Video Streaming App Like Netflix
                          </Link>
                        </Col>
                        <Col lg={3} md={6} className="mt-3 mt-lg-4">
                          <Link
                            href="/how-to-create-music-video-app-like-tiktok"
                            className="menuTitleSm text-decoration-none fw-500"
                          >
                            Music Video App Like Tiktok
                          </Link>
                        </Col>
                        <Col lg={3} md={6} className="mt-3 mt-lg-4">
                          <Link
                            href="/how-much-does-it-cost-to-develop-a-photo-sharing-app-like-instagram"
                            className="menuTitleSm text-decoration-none fw-500"
                          >
                            Photo Sharing App Like Instagram
                          </Link>
                        </Col>
                        <Col lg={3} md={6} className="mt-3 mt-lg-4">
                          <Link
                            href="/how-to-create-an-elearning-app-like-byjus"
                            className="menuTitleSm text-decoration-none fw-500"
                          >
                            E-Learning App Like Byjus
                          </Link>
                        </Col>
                        <Col lg={3} md={6} className="mt-3 mt-lg-4">
                          <Link
                            href="/how-to-create-a-healthcare-app-like-practo"
                            className="menuTitleSm text-decoration-none fw-500"
                          >
                            Healthcare App Like Practo
                          </Link>
                        </Col>
                        <Col lg={3} md={6} className="mt-3 mt-lg-4">
                          <Link
                            href="/how-to-build-an-ecommerce-website-like-amazon-ebay"
                            className="menuTitleSm text-decoration-none fw-500"
                          >
                            E-Commerce App/Website Like Amazon
                          </Link>
                        </Col>
                        <Col lg={3} md={6} className="mt-3 mt-lg-4">
                          <Link
                            href="/how-to-create-a-video-sharing-app-like-youtube"
                            className="menuTitleSm text-decoration-none fw-500"
                          >
                            Video Sharing App Like Youtube
                          </Link>
                        </Col>
                        <Col lg={3} md={6} className="mt-3 mt-lg-4">
                          <Link
                            href="/create-an-elearning-app-like-udemy-lynda"
                            className="menuTitleSm text-decoration-none fw-500"
                          >
                            E-Learning App Like Udemy/Lynda
                          </Link>
                        </Col>
                        <Col lg={3} md={6} className="mt-3 mt-lg-4">
                          <Link
                            href="/cost-to-create-a-food-delivery-app-like-ubereats"
                            className="menuTitleSm text-decoration-none fw-500"
                          >
                            Food Delivery App Like UberEats
                          </Link>
                        </Col>
                        <Col lg={3} md={6} className="mt-3 mt-lg-4">
                          <Link
                            href="/how-to-create-an-app-like-tinder"
                            className="menuTitleSm text-decoration-none fw-500"
                          >
                            Dating App Like Tinder
                          </Link>
                        </Col>
                        <Col lg={3} md={6} className="mt-3 mt-lg-4">
                          <Link
                            href="/create-an-elearning-app-like-coursera"
                            className="menuTitleSm text-decoration-none fw-500"
                          >
                            E-Learning App Like Coursera
                          </Link>
                        </Col>
                        <Col lg={3} md={6} className="mt-3 mt-lg-4">
                          <Link
                            href="/how-to-create-a-healthcare-app-like-zocdoc"
                            className="menuTitleSm text-decoration-none fw-500"
                          >
                            Healthcare App Like Zocdoc
                          </Link>
                        </Col>
                        <Col lg={3} md={6} className="mt-3 mt-lg-4">
                          <Link
                            href="/cost-to-develop-fantasy-sports-betting-app-like-dream11"
                            className="menuTitleSm text-decoration-none fw-500"
                          >
                            Sports Betting App Like Dream11
                          </Link>
                        </Col>
                        <Col lg={3} md={6} className="mt-3 mt-lg-4">
                          <Link
                            href="/cost-to-develop-an-app-like-airbnb"
                            className="menuTitleSm text-decoration-none fw-500"
                          >
                            Cost To Make An App Like Airbnb
                          </Link>
                        </Col>
                        <Col lg={3} md={6} className="mt-3 mt-lg-4">
                          <Link
                            href="/cost-to-develop-a-chat-app"
                            className="menuTitleSm text-decoration-none fw-500"
                          >
                            Cost To Develop A Chat App
                          </Link>
                        </Col>
                        <Col lg={3} md={6} className="mt-3 mt-lg-4">
                          <Link
                            href="/cost-to-develop-sports-betting-app-like-bet365"
                            className="menuTitleSm text-decoration-none fw-500"
                          >
                            Sports Betting App Like Bet365
                          </Link>
                        </Col>
                        <Col lg={3} md={6} className="mt-3 mt-lg-4">
                          <Link
                            href="/cost-to-make-on-demand-grocery-delivery-app-like-instacart"
                            className="menuTitleSm text-decoration-none fw-500"
                          >
                            Grocery Delivery App Like Instacart
                          </Link>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              )}
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  )
}

export default Menu
